import React, { useState, useEffect } from "react";

import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./routes";

import { AlertProvider, useAlert} from "./components/Alert3/AlertContext";
import { registerShowAlert } from "./hooks/fetchWithAuth";
import Tour from "./components/Tour";
import { TourProvider } from "./components/Tour/context";

function AlertRegistrar() {
  const { showAlert } = useAlert();
  

  React.useEffect(() => {
    registerShowAlert(showAlert);
  }, [showAlert]);

  return null; // só registrar a função mesmo
}

export default function App() {

  return (
    <AlertProvider>
      <AlertRegistrar />
    <BrowserRouter>
    <TourProvider>
          <Tour />
          <AppRoutes />
        </TourProvider>
    </BrowserRouter>
    </AlertProvider>
  );
}